export default function ReferenceSectionsController(
  $rootScope,
  loaderService,
  pmSharedModelService,
  editSectionDialog,
  ssDialogService,
) {
  const vm = this;
  vm.handleEditSection = _handleEditSection;

  /** **************************************************
   * Event Handlers
   */

  function _handleEditSection($event, policyDocumentSectionId) {
    loaderService.showViewLoader = true;
    pmSharedModelService.getSection(policyDocumentSectionId)
      .then((section) => {
        loaderService.showViewLoader = false;
        return _showEditSectionDialog($event, {
          policyDocumentId: vm.policyDocumentId,
          permissions: vm.permissions,
          section
        });
      });
  }

  /** **************************************************
   * Private Functions
   */

  function _showEditSectionDialog($event, locals) {
    ssDialogService.dialogs.pm.settingsDialog = ssDialogService.alert(
      editSectionDialog.getOptions($event, locals)
    );
    return ssDialogService.show(ssDialogService.dialogs.pm.settingsDialog);
  }
}

ReferenceSectionsController.$inject = [
  '$rootScope',
  'loaderService',
  'pmSharedModelService',
  'editSectionDialog',
  'ssDialogService',
];
